import { useQuery } from 'react-query';

import { api } from '../../../../static/api';
import { QueryAliases } from '../../../../types/QueryAliases';
import useAxiosInstance from '../../../axios/useAxiosInstance';
import { ApiTeamRef, hasTeamRef, toTeamMessage } from './transformTeamMessage';

interface ApiReceivedMessage {
  createdAt: string;
  game: number;
  id: number;
  message: string;
  receiver: string;
  sender: ApiTeamRef | string | undefined;
  wasRead: boolean;
}

interface useGameReceivedMessagesProps {
  gameId: string;
}

const useGameReceivedMessages = ({ gameId }: useGameReceivedMessagesProps) => {
  const axiosInstance = useAxiosInstance();

  const { data, isLoading, isError } = useQuery(
    [QueryAliases.GAME_RECEIVED_MESSAGES(gameId)],
    () => axiosInstance.get(api.endpoints.GAME_RECEIVED_MESSAGES({ gameId })),
    {
      refetchOnMount: true,
      refetchInterval: 15000,
    },
  );

  const apiMessages: ApiReceivedMessage[] | undefined = data?.data;

  const iMessages = !!apiMessages
    ? apiMessages
        .filter(apiMessage => hasTeamRef(apiMessage.sender))
        .map(apiMessage => toTeamMessage(apiMessage, apiMessage.sender as ApiTeamRef, true))
    : undefined;

  return { messages: iMessages, isLoading, isError };
};

export default useGameReceivedMessages;
